
import { Vue, Watch, Component } from "vue-property-decorator";
import { mdiPlus, mdiLink } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import debounce from "debounce";
import { ROWS_PER_PAGE } from "@/utils/constants";

@Component({
  components: { SvgIcon },
})

export default class Relay extends Vue {

  private loading: boolean = true;
  private buildings: object[] = [];
  private buildingCount: number = 0;
  private pagination: any = {};
  private headers: object[] = [
    { value: "name", sortable: true },
    { value: "Address.address", sortable: false },
    { value: "mountings", sortable: true },
  ];
  private mdiPlus = mdiPlus;
  private mdiLink = mdiLink;

  private ROWS_PER_PAGE = ROWS_PER_PAGE;

  private debouncedGetBuildings = debounce(() => {
    this.getBuildings();
  }, 500);

  @Watch("pagination", { deep: true })
  public handlerPagination(val, oldVal) {
    if (val.page === oldVal.page) {
      val.page = 1;
    }
    this.debouncedGetBuildings();
  }

  public goToBuilding(id) {
    this.$router.push(`/buildings/${id}`);
  }

  private getBuildings() {
    this.loading = true;
    return this.$store.dispatch("admin/buildings/getAll", { query: this.pagination })
      .then((res) => {
        this.buildings = res.rows;
        this.buildingCount = res.count;
      })
      .catch((err) => {
        this.$store.commit("alerts/displayError", {
          msg: err,
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private createMounting(building) {
    this.loading = true;
    return this.$store.dispatch("admin/buildings/createMounting", { building })
      .then((res) => {
        return this.getBuildings();
      })
      .catch((err) => {
        this.$store.commit("alerts/displayError", {
          msg: err,
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

}
